/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2023-09-12 13:33:57
 * @LastEditTime : 2023-09-19 09:55:41
 * @LastEditors  : yangxr
 * @Description  : 退货任务API
 * @FilePath     : \icps_change\src\api\GHnumber\returnGoodsTask.js
 */
import request from '@/utils/request'
export const queryPage = '/icps/system/sign/dataCollection/returnGood/queryPage'
/*删除售料任务*/
export function deleteTask(params) {
    return request({
        url: '/icps/system/sign/dataCollection/returnGood/deleteTask',
        method: 'GET',
        params
    })
}
/*冲销*/
export function backTask(data) {
    return request({
        url: '/icps/system/sign/dataCollection/returnGood/backTask',
        method: 'post',
        data
    })
} 